import React from "react";
import MultiSelectComponent from "./MultiSelectComponent";
import constant from "../../../../appConstants";
import { isNumber } from "lodash"
import NumericFilters from "./numericOperatorFilter";

class MultiSelectFilter extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isOptionsSelected: false,
            options: [],
            selectedOptions: [],
            filteredOptions: [],
            searchTerm: "",
            numericOperator: NumericFilters[0],
            startRange: "",
            endRange: "",
        }
        this.selectedFilters = [];
        this.isNumericData = false;
        this.afterGuiAttached = this.afterGuiAttached.bind(this);
        this.getModel = this.getModel.bind(this);
        this.setModel = this.setModel.bind(this);
        this.isFilterActive = this.isFilterActive.bind(this);
        this.doesFilterPass = this.doesFilterPass.bind(this);
        this.onSelectAll = this.onSelectAll.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onFilterApplied = this.onFilterApplied.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
        this.getUniqueSortedValues = this.getUniqueSortedValues.bind(this);
    }

    // Gets called everytime a popup is shown.Can be used to make any updates based on current grid state when popup is opened.
    // params has hidePopup function that can be called later point in time to hide popup- good to use when you have popup button
     afterGuiAttached(params){
      this.loadOptions();
      this.resetSearch();
    }

    onNewRowsLoaded(params){
        // setTimeout is needed because the rowdata is not available immeditaley for loadOptions
        setTimeout(() => {
            this.loadOptions();
            this.resetSearch();
            this.onFilterApplied();
        }, 0);
      }

    // gets the filterState for storing
    getModel() {
        return [
        ...this.selectedFilters,
        this.isNumericFilterValid()
            ? { startRange: this.state.startRange, endRange: this.state.endRange, numericOperator: this.state.numericOperator }
            : null
        ].filter(Boolean);
    }    

    // Set filter state
    setModel(model) {
        if (model === null) {
            this.selectedFilters = [];
            this.setState({
                startRange: '',
                endRange: ''
            });
            this.resetSearch();
        } else {
            this.selectedFilters = this.state.options.filter((option) => option.checked);
        }
    }

    // The grid calls this to knoe if filter icon on header should be shown, Return true to show
    isFilterActive(){
        return (this.selectedFilters && this.selectedFilters.length > 0) || this.isNumericFilterValid();
    }

    // Grid asks each active filter if each row in grid passes. Return true if row passes the filter. If false then it is removed the final set of filtered rows
    // params contains the node attributes and data object for a row
    doesFilterPass(params){
            let currentValue = this.props.valueGetter(params.node);
            // if value is not a number & is not valid value(undefined, null,"") assign "" as value, so that it can filtered in blank selection
            if(!isNumber(currentValue) && !Boolean(currentValue)){
                currentValue = "";
            }

            if(this.isNumericData && !isNaN(parseInt(currentValue))){
                const { startRange, endRange} = this.state;
                const returnValue = (this.state.numericOperator.filter && this.state.numericOperator.filter(Number(currentValue),startRange,endRange)) ||this.selectedFilters.findIndex(option=>option.value === currentValue) > -1;
                return returnValue;
            }
            return this.selectedFilters.findIndex(option=>option.value === currentValue || (option.value.toString().toUpperCase() === currentValue.toString().toUpperCase())) > -1;
    }

    isNumericFilterValid=()=> {
        return this.isNumericData && !isNaN(parseInt(this.state.startRange)) && (this.state.numericOperator.needsRange ? !isNaN(parseInt(this.state.endRange)) : true);
    }

    // Load options for multiselector from the value in grid for that column
    loadOptions(){
        let options = [];
        this.props.api.forEachNode(node => {
            const value = this.props.valueGetter(node);
            options.push(value);
        });
        options = this.getUniqueSortedValues(options);
        options = options.map(option => {
            const opt = this.selectedFilters.find(opt => opt.value === option);
            return { label: option === "" ? constant.BLANK : option , value: option, checked : opt ? opt.checked : false}
        });
        this.setState({
            options: options.sort()
        })
    }

    resetSearch(){
        this.setState(state =>({
            filteredOptions: state.options,
            searchTerm: "",
            isOptionsSelected: this.selectedFilters.length > 0
        }));
    }


    onSelectAll(checked){
        this.setState(state => ({
            isOptionsSelected: checked,
            filteredOptions: state.filteredOptions.map(option => {
                option.checked = checked;
                return option;
            })
        }),this.onFilterApplied);

    }

    onOptionSelected(option){
        this.state.filteredOptions.find(opt => opt.value === option.value).checked = option.checked;
        this.setState(state => ({
            filteredOptions: state.filteredOptions,
            isOptionsSelected: state.filteredOptions.filter(option => option.checked).length > 0
        }), this.onFilterApplied);
    }

    onSearch(searchValue){
        const filteredOptions = this.state.options.filter(option => option.value.includes(searchValue) || option.value.includes(searchValue.toUpperCase()));
        const selectedOptionCount = filteredOptions.filter(option => option.checked).length
        this.setState({
            filteredOptions,
            searchTerm: searchValue,
            isOptionsSelected: selectedOptionCount > 0
        });
    }

    onFilterApplied(params){
         this.selectedFilters = [...this.state.options.filter(option => option.checked)];
         this.props.filterChangedCallback();
    }

    getUniqueSortedValues(array){
        array = [...new Set([...array])]; // creating new set remove duplicate values from array
        const intialLength = array.length;
        this.isNumericData = true;
        array = array.filter(element => isNumber(element) || element)
                     .map(element => {
                         if(this.isNumericData && isNaN(element)){
                             this.isNumericData = false;
                         }
                         return element;
                     }); // get formatted value
        array.sort(); //sorts string value
        array.sort((currentValue,nextValue) => currentValue - nextValue); // sorts numeric values
        this.isNumericData = array.length ? this.isNumericData : false;
        // Override the filter type if specified in the config , in filterParams.filterType
        if(this.props.filterType){
            this.isNumericData = this.props.filterType === constant.FILTER_TYPES.NUMBER
        }

        if(intialLength > array.length){
            array.push("");
        }
        return array;
    }

    numericOpertaorUpdated = (numericOperator) => {
        this.setState({
            numericOperator
        },this.onFilterApplied)
    }

    numericRangeUpdate = (range, value) => {
        this.setState({
            [range]: value ? Number(value) : ""
        },this.onFilterApplied)
    }

    render(){
        return(
            <MultiSelectComponent
                searchTerm={this.state.searchTerm}
                onSelectAll={this.onSelectAll}
                options={this.state.filteredOptions}
                searchValue={this.state.searchValue}
                onSearch={this.onSearch}
                onOptionSelected={this.onOptionSelected}
                onClear={this.onClearFilter}
                onFilterApplied={this.onFilterApplied}

                isNumericFilter={this.isNumericData}
                startRange={this.state.startRange}
                endRange={this.state.endRange}
                numericOperator= {this.state.numericOperator}
                numericOperatorUpdated={this.numericOpertaorUpdated}
                numericRangeUpdate = { this.numericRangeUpdate}
            />
        )
    }
}
export default MultiSelectFilter;